import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// Global error handler to prevent 401 errors from showing as runtime errors
window.addEventListener('unhandledrejection', (event) => {
  // Check if this is a 401 error that we've already handled
  if (event.reason && event.reason.response && event.reason.response.status === 401) {
    // Prevent the error from showing up in the console
    event.preventDefault();
    return;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
